import {
  getTranslations as getTranslationsNextIntl,
  getMessages as getMessagesNextIntl,
  getLocale as getLocaleNextIntl
} from "next-intl/server";
import { LOCALE_TO_DIRECTORY, type Locale, type Namespace } from "./constants";

/**
 * Server-side wrapper around next-intl's getTranslations that works with our locale mapping.
 */
export async function getTranslations(namespace: Namespace) {
  return await getTranslationsNextIntl(namespace);
}

/**
 * Server-side wrapper around next-intl's getMessages that maps new simplified locales
 * to existing Smartling-compatible directory structure.
 */
export async function getMessages(options?: { locale?: string }) {
  if (!options?.locale) {
    return await getMessagesNextIntl();
  }

  const mappedLocale =
    LOCALE_TO_DIRECTORY[options.locale as Locale] || options.locale;
  return await getMessagesNextIntl({ locale: mappedLocale });
}

/**
 * Server-side wrapper around next-intl's getLocale - returns the current locale.
 */
export async function getLocale() {
  return await getLocaleNextIntl();
}
